import React from "react";
import PageTemplate from "../components/PageTemplate";
import QueryStringsHeaderMobile from "../components/targeting/QueryStringsHeaderMobile";
import QueryStringsBody from '../components/targeting/QueryStringsBody';

const QueryStrings = () => {
  return (
    <PageTemplate
      title="Query String Parameters"
      mobileHeader={<QueryStringsHeaderMobile/>}
      sidebarTitle="Query Parameters"
      sidebarSubtitle="Target visitors by using query strings."
      centered
      fullWidth
    >
      <QueryStringsBody/>
    </PageTemplate>
  );
};

export default QueryStrings;
